import useLocalStorage from './useLocalStorage';

const ENHANCED_GRID_KEY = 'enhancedGridEnabled';

export default function useEnhancedGrid() {
  const [enhancedGridEnabled, setEnhancedGridEnabled] = useLocalStorage<boolean>(
    ENHANCED_GRID_KEY,
    false
  );

  return {
    enhancedGridEnabled,
    setEnhancedGridEnabled
  };
}

